// Format currency
import DirhamIcon from '../assets/images/dirham-symbol.png';

export const getCurrencyData = (amount) => {
  const value = amount ?? 0;

  return {
    amount: new Intl.NumberFormat('en-AE', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(value),
    icon: DirhamIcon,
    symbol: 'AED',
  };
};

// Format currency as string (e.g., "₹50.00" or "AED 50.00")
export const formatCurrency = (amount) => {
  const value = parseFloat(amount) || 0;
  return new Intl.NumberFormat('en-AE', {
    style: 'currency',
    currency: 'UAE',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

// Format date
export const formatDate = (dateString) => {
  if (!dateString) return '';
  return new Date(dateString).toLocaleDateString('en-IN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

// Format date time
export const formatDateTime = (dateString) => {
  if (!dateString) return '';
  return new Date(dateString).toLocaleString('en-IN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

// Get image URL
export const getImageUrl = (imagePath) => {
  if (!imagePath) return '';
  
  // If already a full URL (http:// or https://), return as is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  
  // If path starts with storage/, use it directly, otherwise prepend storage/
  const path = imagePath.startsWith('storage/') ? imagePath : `storage/${imagePath}`;
  const baseUrl = (import.meta.env.VITE_API_URL?.replace('/api/v1', '') || 'http://127.0.0.1:8000');
  
  // Remove trailing slash from baseUrl if present
  const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  
  // Ensure path doesn't start with / to avoid double slashes
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  
  return `${cleanBaseUrl}/${cleanPath}`;
};


export const formatPhoneNumber = (phone = '') => {
  const cleaned = String(phone).replace(/\D/g, '');
  const nbsp = '\u00A0';

  if (cleaned.length === 12 && cleaned.startsWith('9715')) {
    return `+971${nbsp}${cleaned.slice(3, 5)}${nbsp}${cleaned.slice(5, 8)}${nbsp}${cleaned.slice(8, 12)}`;
  }

  if (cleaned.length === 11 && cleaned.startsWith('971')) {
    return `+971${nbsp}${cleaned.slice(3, 5)}${nbsp}${cleaned.slice(5, 8)}${nbsp}${cleaned.slice(8, 11)}`;
  }

  if (cleaned.length === 9 && cleaned.startsWith('5')) {
    return `+971${nbsp}${cleaned.slice(0, 2)}${nbsp}${cleaned.slice(2, 5)}${nbsp}${cleaned.slice(5, 9)}`;
  }

  return phone;
};

/**
 * Format date for API (YYYY-MM-DD)
 * @param {Date|string} date - Date to format
 * @returns {string} Formatted date string
 */
export const formatDateForApi = (date) => {
  if (!date) return '';
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Sanitize filters by removing empty, null, undefined, or empty array values
 * This prevents sending "All" filter values to the API
 * 
 * @param {Object} filters - Filter object to sanitize
 * @returns {Object} - Sanitized filter object with only valid filter values
 */
export const sanitizeFilters = (filters) => {
  if (!filters || typeof filters !== 'object') {
    return {};
  }

  const sanitized = {};

  Object.keys(filters).forEach((key) => {
    const value = filters[key];

    // Skip null, undefined, or empty string
    if (value === null || value === undefined || value === '') {
      return;
    }

    // Skip empty arrays
    if (Array.isArray(value) && value.length === 0) {
      return;
    }

    // Include the filter if it has a valid value
    sanitized[key] = value;
  });

  return sanitized;
};